import styled from 'styled-components';
import BackForth from '../../assets/icons/sessions/back-forth-arrows.svg';
import Stopwatch from '../../assets/icons/sessions/stopwatch.svg';

const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-bottom: 39px;
`;

const DurationColumn = styled.div`
  flex-shrink: 1;
`;

const MeasurementColumn = styled.div`
  flex-grow: 1;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: row nowrap;
  margin-bottom: 2.25rem;
`;

const Title = styled.h2(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.larger};
    font-weight: ${type.weight.bold};
    color: ${color.grayscale[0]};
    margin: 0 0 0 1rem;
  `;
});

const StatList = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
`;

const Stat = styled.div(({ theme }) => {
  const { color } = theme;

  return `
    text-align: center;
    padding: 0 30px;

    &:not(:last-child) {
      border-right: 1px solid ${color.grayscale[700]};
    }
  `;
});

const Number = styled.div(({ theme }) => {
  const { color, type } = theme;
  return `
    font-weight: ${type.black};
    font-size: ${type.size.huge};
    color: ${color.grayscale[0]};
  `;
});

const Description = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.small};
    color: ${color.grayscale[400]};
    text-transform: capitalize;
  `;
});

const GameDuration = styled.div(({ theme }) => {
  const { type } = theme;

  return `
    font-size: ${type.size.larger};
  `;
});

const DurationFormat = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.small};
    color: ${color.grayscale[400]};
    text-transform: capitalize;
  `;
});

const TwoControllerStatContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  gap: 2rem;
`;

const ControllerSectionTitle = styled.div(({ theme }) => {
  const { type } = theme;

  return `
    font-size: ${type.size.small};
    margin-bottom: 5px;
  `;
});

const SvgIcon = styled.img`
  height: 1.75rem;
  width: 1.75rem;
  display: inline-block;
`;

const Statistic = ({ statistic }) => {
  const { data, name } = statistic;

  return (
    <Stat>
      <Number>{data}</Number>

      <Description>{name}</Description>
    </Stat>
  );
};

const Measurements = ({ duration, measurement, durationTitle }) => {
  const { controller_num, data, measurement_name } = measurement;

  return (
    <Container>
      <DurationColumn>
        <TitleWrapper>
          <SvgIcon src={Stopwatch} alt="" />

          <Title>{durationTitle ? durationTitle : 'Duration'}</Title>
        </TitleWrapper>

        <GameDuration>{duration}</GameDuration>

        <DurationFormat>MM:SS</DurationFormat>
      </DurationColumn>

      <MeasurementColumn>
        <TitleWrapper>
          <SvgIcon src={BackForth} alt="" />

          <Title>{measurement_name}</Title>
        </TitleWrapper>

        {controller_num === 1 && (
          <StatList>
            {data[0].map((stat) => (
              <Statistic statistic={stat} key={stat.name} />
            ))}
          </StatList>
        )}

        {controller_num === 2 && (
          <>
            <TwoControllerStatContainer>
              <div>
                <ControllerSectionTitle>Left Controller Movements</ControllerSectionTitle>

                <StatList>
                  {data[0].map((stat) => (
                    <Statistic statistic={stat} key={stat.name} />
                  ))}
                </StatList>
              </div>

              <div>
                <ControllerSectionTitle>Right Controller Movements</ControllerSectionTitle>

                <StatList>
                  {data[1].map((stat) => (
                    <Statistic statistic={stat} key={stat.name} />
                  ))}
                </StatList>
              </div>
            </TwoControllerStatContainer>
          </>
        )}
      </MeasurementColumn>
    </Container>
  );
};

export default Measurements;
